import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  lede?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
  as?: 'h1' | 'h2';
}
export function SectionHeading({
  eyebrow,
  title,
  lede,
  align = 'left',
  tone = 'dark',
  as = 'h2'
}: SectionHeadingProps) {
  const Tag = as;
  return <div className={`${align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}`} data-id="element-222" data-mp="3k0yfs5gosx7n">
      {eyebrow && <p className={`mb-4 text-xs uppercase tracking-[0.18em] ${tone === 'dark' ? 'text-aqua-600' : 'text-aqua-300'}`} data-id="element-223" data-mp="bmgecml94fx0">
          {eyebrow}
        </p>}
      <Tag className={`font-display text-3xl font-semibold leading-[1.08] tracking-tightest sm:text-4xl lg:text-[44px] ${tone === 'dark' ? 'text-ink-950' : 'text-white'}`} data-id="element-224" data-mp="1shfpxkdze9t">
        {title}
      </Tag>
      {lede && <p className={`mt-5 text-base leading-relaxed ${tone === 'dark' ? 'text-ink-700' : 'text-white/65'}`} data-id="element-225" data-mp="zazm910e2qok">
          {lede}
        </p>}
    </div>;
}